export var getScrollItemsWidgetTitle = text => {
  return {
    text,
    type: 'body-para-sm-bold'
  };
};
export var getRenderListData = (showFullList, showExpandCta, data, initialItemCount) => {
  return showFullList || !showExpandCta ? data : data.slice(0, Math.min(data.length, initialItemCount));
};